import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ExperimentService } from '@services/experiment/experiment.service';
import { REGIMEN_ROUTE_PATHS } from 'client/app/user/user-view/user-regimen/regimen.constants';

export const regimenNewRoutesGuard: CanActivateFn = async () => {
  const experimentService = inject(ExperimentService);
  const router = inject(Router);
  await experimentService.experimentsLoaded;
  if (experimentService.regimenRouteExperiment) return true;
  return router.createUrlTree([REGIMEN_ROUTE_PATHS.ROOT]);
};
